/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevNumberFilter
 */
export interface DevNumberFilter {
    /**
     * 
     * @type {Array<number>}
     * @memberof DevNumberFilter
     */
    values?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DevNumberFilter
     */
    min?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DevNumberFilter
     */
    minInclusive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DevNumberFilter
     */
    max?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DevNumberFilter
     */
    maxInclusive?: boolean;
}

/**
 * Check if a given object implements the DevNumberFilter interface.
 */
export function instanceOfDevNumberFilter(value: object): value is DevNumberFilter {
    return true;
}

export function DevNumberFilterFromJSON(json: any): DevNumberFilter {
    return DevNumberFilterFromJSONTyped(json, false);
}

export function DevNumberFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevNumberFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'values': json['values'] == null ? undefined : json['values'],
        'min': json['min'] == null ? undefined : json['min'],
        'minInclusive': json['minInclusive'] == null ? undefined : json['minInclusive'],
        'max': json['max'] == null ? undefined : json['max'],
        'maxInclusive': json['maxInclusive'] == null ? undefined : json['maxInclusive'],
    };
}

export function DevNumberFilterToJSON(json: any): DevNumberFilter {
    return DevNumberFilterToJSONTyped(json, false);
}

export function DevNumberFilterToJSONTyped(value?: DevNumberFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'values': value['values'],
        'min': value['min'],
        'minInclusive': value['minInclusive'],
        'max': value['max'],
        'maxInclusive': value['maxInclusive'],
    };
}

